import { render, staticRenderFns } from "./value_stream_metrics.vue?vue&type=template&id=2b95b8b2"
import script from "./value_stream_metrics.vue?vue&type=script&lang=js"
export * from "./value_stream_metrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports